import { render, staticRenderFns } from "./DeviceBatchAddDrawer.vue?vue&type=template&id=54b1a83a&scoped=true&"
import script from "./DeviceBatchAddDrawer.vue?vue&type=script&lang=js&"
export * from "./DeviceBatchAddDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBatchAddDrawer.vue?vue&type=style&index=0&id=54b1a83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b1a83a",
  null
  
)

export default component.exports